import React from 'react'; // eslint-disable-line
import constants from '../../constants';
import PreviewModuleBottomMenuItem from './PreviewModuleBottomMenuItem';
import PreviewEventsItem from './PreviewEventsItem';
import PreviewFeaturedSermonsItem from './PreviewFeaturedSermonsItem';
import Checkin from '../svg/preview/Checkin';

class PreviewDiscover extends React.Component {
    render() {
        let currentClass;
        if (this.props.module.showFeatured) {
            currentClass = 'feat-event-on-grid-off';
        } else {
            currentClass = 'feat-event-off-grid-off';
        }

        let modules = this.props.menuItems && this.props.menuItems.length > 0
            ? this.props.menuItems.filter((item) => { return item.displayOrder > -1; })
            : [];
        modules = modules.sort((a, b) => { return a.displayOrder - b.displayOrder; });
        if (modules.length > 5 && this.props.menuStyle === 1) {
            modules = modules.slice(0, 4);
            modules.push({ displayOrder: 5, title: 'More', subType: 'more' });
        }
        const simpleEvents = typeof (this.props.forms) === 'undefined' ? [] : this.props.forms;

        return (
            <div className={`preview-content preview-content_modules__discover menu-${this.props.menuStyle} ${currentClass}`}>
                {this.props.menuStyle === constants.MenuStyle.find((c) => { return c.Name === 'Tiled'; }).Id && (
                    <div className="tile-right">
                        <svg width="22px" height="22px" viewBox="0 0 22 22" version="1.1" xmlns="http://www.w3.org/2000/svg">
                            <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
                                <g id="Discover-/-Tiled-Menu-Copy" transform="translate(-339.000000, -32.000000)" stroke={this.props.primaryText}>
                                    <g id="Navigation-Bar">
                                        <g id="Right-Accessory" transform="translate(205.000000, 21.000000)">
                                            <g id="Group-2">
                                                <g id="↳-Icon" transform="translate(135.000000, 12.000000)">
                                                    <g id="microsoft">
                                                        <rect id="Rectangle-path" x="0" y="0" width="9" height="9" />
                                                        <polygon id="Rectangle-path" transform="translate(15.500000, 4.500000) rotate(-180.000000) translate(-15.500000, -4.500000) " points="11 0 20 0 20 9 11 9" />
                                                        <polygon id="Rectangle-path" points="0 11 9 11 9 20 0 20" />
                                                        <polygon id="Rectangle-path" transform="translate(15.500000, 15.500000) rotate(-180.000000) translate(-15.500000, -15.500000) " points="11 11 20 11 20 20 11 20" />
                                                    </g>
                                                </g>
                                            </g>
                                        </g>
                                    </g>
                                </g>
                            </g>
                        </svg>
                    </div>
                )}
                {this.props.menuStyle === constants.MenuStyle.find((c) => { return c.Name === 'SlideOut'; }).Id && (
                    <div className="hamburger-left">
                        <svg width="18px" height="12px" viewBox="0 0 23 15" version="1.1" xmlns="http://www.w3.org/2000/svg">
                            <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                <g id="Discover-/-Hamburger-Menu-Copy" transform="translate(-14.000000, -36.000000)" fill={this.props.primaryText} fillRule="nonzero">
                                    <g id="Navigation-Bar">
                                        <g id="Left-Accessory" transform="translate(0.000000, 21.000000)">
                                            <g id="Group-2">
                                                <g id="↳-Icon" transform="translate(11.000000, 8.000000)">
                                                    <path d="M3.5,21 L25.5,21 C25.7761424,21 26,21.2238576 26,21.5 C26,21.7454599 25.8231248,21.9496084 25.5898756,21.9919443 L25.5,22 L3.5,22 C3.22385763,22 3,21.7761424 3,21.5 C3,21.2545401 3.17687516,21.0503916 3.41012437,21.0080557 L3.5,21 Z M3.5,14 L16.5,14 C16.7761424,14 17,14.2238576 17,14.5 C17,14.7454599 16.8231248,14.9496084 16.5898756,14.9919443 L16.5,15 L3.5,15 C3.22385763,15 3,14.7761424 3,14.5 C3,14.2545401 3.17687516,14.0503916 3.41012437,14.0080557 L3.5,14 Z M3.5,7 L25.5,7 C25.7761424,7 26,7.22385763 26,7.5 C26,7.74545989 25.8231248,7.94960837 25.5898756,7.99194433 L25.5,8 L3.5,8 C3.22385763,8 3,7.77614237 3,7.5 C3,7.25454011 3.17687516,7.05039163 3.41012437,7.00805567 L3.5,7 L25.5,7 L3.5,7 Z" id="Shape" />
                                                </g>
                                            </g>
                                        </g>
                                    </g>
                                </g>
                            </g>
                        </svg>
                    </div>
                )}
                <div className={`module-preview discover-preview ${this.props.module.showFeatured ? 'featured-sermon' : ''}`}>

                    <div className="module-header">
                        <div className="module-header_top">
                            {this.props.menuStyle === constants.MenuStyle.find((c) => { return c.Name === 'Bottom'; }).Id && (
                                <div className="profile">
                                    {this.props.checkin
                                    && <Checkin activeColor={this.props.primaryText} />}
                                    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" style={{ marginBottom: '5px' }}>
                                        <path
                                            d="M2.5913,1.9344L9.452,8.3302C10.4112,9.2243 11.8981,9.2255 12.8586,8.3329L19.5938,2.0739C19.1612,1.7154 18.6057,1.5 18,1.5L4,1.5C3.4775,1.5 2.9925,1.6603 2.5913,1.9344ZM1.8944,2.6517C1.6447,3.0408 1.5,3.5035 1.5,4L1.5,14C1.5,15.3807 2.6193,16.5 4,16.5L18,16.5C19.3807,16.5 20.5,15.3807 20.5,14L20.5,4C20.5,3.5872 20.3999,3.1977 20.2227,2.8546L13.5394,9.0654C12.1946,10.3151 10.1129,10.3134 8.7702,9.0617L1.8944,2.6517ZM4,0.5L18,0.5C19.933,0.5 21.5,2.067 21.5,4L21.5,14C21.5,15.933 19.933,17.5 18,17.5L4,17.5C2.067,17.5 0.5,15.933 0.5,14L0.5,4C0.5,2.067 2.067,0.5 4,0.5Z"
                                            strokeWidth="0.1"
                                            fill={this.props.primaryText}
                                            fillRule="evenOdd"
                                            stroke={this.props.primaryText}
                                        />
                                    </svg>
                                    <svg width="15" height="15" viewBox="0 0 15 15" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M7.4 14.192a6.64 6.64 0 1 0 0-13.28 6.64 6.64 0 0 0 0 13.28zm0-3.924c-1.333 0-2.415-1.383-2.415-2.716V6.345a2.415 2.415 0 0 1 4.83 0v1.207c0 1.333-1.082 2.716-2.415 2.716zm-1.51-.65l-1.803 1.034a1.811 1.811 0 0 0-.912 1.573v.45m8.45 0v-.45c0-.65-.348-1.25-.912-1.572L8.911 9.619" stroke={this.props.primaryText} strokeWidth=".664" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>

                                </div>
                            )}
                        </div>
                        <div className="module-header_bottom">
                            <h2>{this.props.menuItem?.title}</h2>
                        </div>
                    </div>
                    <div className="module-sermons-body">
                        {this.props.media.select && this.props.module.showFeatured
                        && this.props.media.select.items
                        && (
                            <PreviewFeaturedSermonsItem
                                item={this.props.module.featuredId
                                    ? this.props.media.select.items
                                        .find((m) => {
                                            return m.guid === this.props.module.featuredId;
                                        })
                                    : this.props.media.select.items[0]}
                                primaryText={this.props.primaryText}
                                accentColor={this.props.accentColor}
                            />
                        )}

                        {this.props.module.showUpcomingEvents
                        && simpleEvents.map((med, i) => {
                            /* eslint-disable */
                            return (
                                <PreviewEventsItem
                                    discover
                                    accentColor={this.props.accentColor}
                                    primaryText={this.props.primaryText}
                                    item={med}
                                    key={i}
                                />
                            );
                           /* eslint-enable */
                        })}

                        {!this.props.module.showUpcomingEvents && !this.props.module.showFeatured && <div className="empty-discover" />}
                    </div>

                    {this.props.menuStyle === constants.MenuStyle.find((c) => { return c.Name === 'Bottom'; }).Id && (

                        <div className="menu-list bottom-wrap">

                            {modules
                                .sort((a, b) => {
                                    return a.displayOrder > b.displayOrder;
                                })
                                .map((md, i) => {
                                    /* eslint-disable */
                                    return (
                                        <PreviewModuleBottomMenuItem
                                            key={i}
                                            menuItem={md}
                                            active={md.subType == 1}
                                            activeColor={this.props.actionColor}
                                        />
                                    );
                                    /* eslint-enable */
                                })}
                        </div>

                    )}
                </div>
            </div>
        );
    }
}

export default PreviewDiscover;
